module.exports = __webpack_public_path__ + "static/media/footer_stroke.a760d002.png";